// Code from: https://deno.land/std@0.208.0/async/deferred.ts?source

// FIXME: Next.js에서 `Promise.withResolvers`가 제대로 polyfill 되고나면 마이그레이션 할 것.
// https://github.com/vercel/next.js/issues/63104

export interface Deferred<T> extends Promise<T> {
  readonly state: 'pending' | 'fulfilled' | 'rejected';
  resolve(value?: T | PromiseLike<T>): void;
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  reject(reason?: any): void;
}

export default function deferred<T>(): Deferred<T> {
  let methods;
  let state = 'pending';
  const promise = new Promise<T>((resolve, reject) => {
    methods = {
      async resolve(value: T | PromiseLike<T>) {
        await value;
        state = 'fulfilled';
        resolve(value);
      },
      // oxlint-disable-next-line @typescript-eslint/no-explicit-any
      reject(reason?: any) {
        state = 'rejected';
        reject(reason);
      },
    };
  });
  Object.defineProperty(promise, 'state', { get: () => state });
  return Object.assign(promise, methods) as Deferred<T>;
}
